import React from "react";
import { ArrowRight, Trophy } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ReadyForKickoff() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="28007" id="initiate-bulk-order" className="relative w-full overflow-hidden bg-primary py-24 md:py-32">
      {}
      <div className="pointer-events-none absolute inset-0 z-0 opacity-20 mix-blend-overlay" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)' opacity='1'/%3E%3C/svg%3E")`
    }} />

      {}
      <div className="pointer-events-none absolute inset-0 z-0 bg-[radial-gradient(circle_at_center,_var(--color-ring)_0%,_transparent_60%)] opacity-20" />

      {}
      <div ref={ref} className={cn("container relative z-10 mx-auto px-4 text-center transition-all duration-1000 ease-out", isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0")}>
        <div className="mx-auto max-w-4xl space-y-8">
          {}
          <div className="flex justify-center">
            <div className="flex h-16 w-16 items-center justify-center rounded-sm bg-ring/10 ring-1 ring-ring/50 backdrop-blur-sm">
              <Trophy className="h-8 w-8 text-ring" />
            </div>
          </div>

          {}
          <h2 className="font-serif text-4xl font-black uppercase tracking-tighter text-white sm:text-5xl md:text-6xl lg:text-7xl">
            READY FOR YOUR <span className="text-ring">NEXT PROJECT?</span>
          </h2>

          {}
          <p className="mx-auto max-w-2xl text-lg font-medium text-primary-foreground/80 md:text-xl">
            Streamline your supply chain with Australia's reliable wholesale partner. We deliver bulk building materials and hardware directly to your site.
          </p>

          {}
          <div className="flex flex-col items-center justify-center gap-4 sm:flex-row sm:gap-6 pt-4">
            <Button asChild size="lg" className="h-14 min-w-[200px] rounded-sm bg-ring text-primary text-base font-bold uppercase tracking-wide shadow-[0_0_20px_rgba(var(--color-ring),0.4)] transition-transform hover:scale-105 hover:shadow-[0_0_30px_rgba(var(--color-ring),0.6)]">
              <Link to="/ContactPage">
                Request Custom Quote
                <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
            </Button>

            <Button asChild variant="outline" size="lg" className="h-14 min-w-[200px] rounded-sm border-2 border-ring/50 bg-transparent text-base font-bold uppercase tracking-wide text-ring hover:border-ring hover:bg-ring hover:text-primary">
              <Link to="/ProductsPage">Browse Products</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}